import { z } from 'zod';

import { jobArchitectureGenerationInfoSchema } from '~/shared/data-contract/job-architecture';
import { creatorSchema, jobProfileComponentSchema } from '~/shared/data-contract/job-profile';

export const employmentTypeSchema = z.enum([
    'employee',
    'trainee',
    'apprentice',
    'intern',
    'working-student',
    'contractor',
    'temp',
]);

export type EmploymentType = z.infer<typeof employmentTypeSchema>;

export const contractDurationSchema = z.enum(['permanent', 'fixed-term']);

export type ContractDuration = z.infer<typeof contractDurationSchema>;

export const workModeSchema = z.enum(['100%', '80%', '60%', '50%', '40%', '20%', '10%']);

export type WorkMode = z.infer<typeof workModeSchema>;

export const userInvitationShortSchema = z.object({
    id: z.uuid(),
    emailAddress: z.email(),
});

export const positionDetailsSharedSchema = z.object({
    id: z.uuid(),
    contractDuration: contractDurationSchema,
    creator: creatorSchema.optional(),
    custom: z.record(z.string(), z.union([z.string(), z.date(), z.number().int(), z.boolean()])).optional(),
    department: z.string().optional(),
    employmentType: employmentTypeSchema,
    externalId: z.string().optional(),
    hiringManager: creatorSchema.optional(),
    invitation: userInvitationShortSchema.optional(),
    jobArchitectureItemId: z.uuid(),
    jobArchitectureItems: z.record(z.string(), z.uuid()),
    jobProfile: jobProfileComponentSchema.optional(),
    location: z.string().optional(),
    owner: creatorSchema.optional(),
    salary: z.string().optional(),
    salaryRange: z.string().optional(),
    title: z.string(),
    workMode: workModeSchema,
});

export const positionDetailsResponseSchema = positionDetailsSharedSchema.extend({
    assignee: creatorSchema.optional(),
    profileGenerationInfo: jobArchitectureGenerationInfoSchema.optional(),
});

export type PositionDetailsResponse = z.infer<typeof positionDetailsResponseSchema>;

export const positionDetailsRequestSchema = positionDetailsSharedSchema.extend({
    assignee: z.uuid().nullable(),
});

export type PositionDetailsRequest = z.infer<typeof positionDetailsRequestSchema>;
